import request from "../../../utils/request";

export const getExpressFreight = '/expressFreight/';

export function getExpressList() {
    return request.request({
        method: "get",
        url: "/expressFreight/getExpressList"
    })
}

export function getExpressFreightDetail(id: any) {
    return request.request({
        method: "get",
        url: "/expressFreight/detail",
        params: {id: id}
    })
}

export function addExpressFreight(values: any) {
    return request.request({
        method: "post",
        url: '/expressFreight/',
        data: values
    })
}

export function switchStatus(id: any) {
    return request.request({
        url: '/expressFreight/switchStatus',
        method: "get",
        params: {id: id}
    })
}

export function addWeightItem(expressFreightId: number, expressFreightWeightItemParamList: any) {
    return request.request({
        url: '/expressFreight/addWeightItem',
        method: 'post',
        params: {expressFreightId: expressFreightId},
        data: expressFreightWeightItemParamList
    })
}

export function addBoxItem(expressFreightId: number, expressFreightBoxItemParamList: any) {
    return request.request({
        url: '/expressFreight/addBoxItem',
        method: 'post',
        params: {expressFreightId: expressFreightId},
        data: expressFreightBoxItemParamList
    })
}

export function importExpressFreightWeight(expressFreightId: number, file: File) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('expressFreightId', expressFreightId.toString())
    return request.request({
        url: '/expressFreight/detail/importWeight',
        method: 'post',
        data: formData
    })
}

export function importExpressFreightBox(expressFreightId: number, file: File) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('expressFreightId', expressFreightId.toString())
    return request.request({
        url: '/expressFreight/detail/importBox',
        method: 'post',
        data: formData
    })
}